
import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config.json";

import {
    Box,
    Button,
    Container,
    Typography,
    Paper,
} from "@mui/material";

const RankingsPage = () => {
    const [rankType, setRankType] = useState(15);
    const [rankList, setRankList] = useState([]);

    const apiEndPoint = config.apiEndPoint + "statistics/";

    const rankingButtons = [
        { id: 15, name: "Trojan" },
        { id: 25, name: "Warrior" },
        { id: 45, name: "Archer" },
        { id: 135, name: "Water" },
        { id: 145, name: "Fire" },
        { id: 2, name: "Money" },
        { id: 3, name: "Virtue" },
        { id: 4, name: "PK" },
        { id: 255, name: "Guilds" },
    ];

    useEffect(() => {
        const fetchRankings = async () => {
            try {
                const { data } = await axios.get(apiEndPoint + rankType);
                setRankList(data);
            } catch (ex) {
                console.log(ex);
            }
        };

        fetchRankings();
    }, [rankType]);

    const getTitle = () => {
        switch (rankType) {
            case 2: return "Money";
            case 3: return "Virtue";
            case 4: return "PK";
            default: return "Power";
        }
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                py: { xs: 5, md: 9 },
                position: "relative",
                overflow: "hidden",
                background:
                    "radial-gradient(circle at 50% -10%, rgba(255,81,35,0.18), transparent 35%), radial-gradient(circle at 0% 45%, rgba(213,47,12,0.08), transparent 30%), linear-gradient(180deg, #030303 0%, #080808 50%, #020202 100%)",
                color: "#fff",

                "&:before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "70%",
                    height: "1px",
                    background:
                        "linear-gradient(90deg, transparent, rgba(255,91,45,0.9), transparent)",
                },

                "&:after": {
                    content: '""',
                    position: "absolute",
                    width: 480,
                    height: 480,
                    borderRadius: "50%",
                    right: -250,
                    top: 180,
                    background: "rgba(255,71,31,0.045)",
                    filter: "blur(130px)",
                    pointerEvents: "none",
                },
            }}
        >
            {/* =====================================================
                BACKGROUND FIRE GLOW
            ====================================================== */}
            <Box
                sx={{
                    position: "absolute",
                    width: 380,
                    height: 380,
                    borderRadius: "50%",
                    left: -200,
                    top: 280,
                    background: "rgba(213,47,12,0.055)",
                    filter: "blur(120px)",
                    pointerEvents: "none",
                }}
            />

            {/* =====================================================
                BACKGROUND GRID
            ====================================================== */}
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    opacity: 0.035,
                    pointerEvents: "none",
                    backgroundImage:
                        "linear-gradient(rgba(255,90,45,0.7) 1px, transparent 1px), linear-gradient(90deg, rgba(255,90,45,0.7) 1px, transparent 1px)",
                    backgroundSize: "45px 45px",
                    maskImage:
                        "linear-gradient(to bottom, black, transparent 85%)",
                    WebkitMaskImage:
                        "linear-gradient(to bottom, black, transparent 85%)",
                }}
            />

            <Container
                maxWidth="lg"
                sx={{
                    position: "relative",
                    zIndex: 2,
                }}
            >

                {/* =====================================================
                    HEADER
                ====================================================== */}
                <Box
                    sx={{
                        mb: { xs: 4, md: 6 },
                        textAlign: "center",
                    }}
                >
                    <Box
                        sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 1,
                            px: 2,
                            py: 0.8,
                            mb: 2,
                            borderRadius: "30px",
                            border:
                                "1px solid rgba(255,92,48,0.2)",
                            background:
                                "rgba(255,65,25,0.055)",
                            boxShadow:
                                "0 0 30px rgba(255,65,25,0.05)",
                        }}
                    >
                        <Box
                            sx={{
                                width: 7,
                                height: 7,
                                borderRadius: "50%",
                                background: "#ff5420",
                                boxShadow:
                                    "0 0 12px rgba(255,84,32,0.9)",
                            }}
                        />

                        <Typography
                            sx={{
                                color: "#ff7135",
                                fontWeight: 800,
                                letterSpacing: "3px",
                                fontSize: "10px",
                                textTransform: "uppercase",
                            }}
                        >
                            VEX • HALL OF LEGENDS
                        </Typography>
                    </Box>

                    <Typography
                        sx={{
                            fontWeight: 900,
                            color: "#fff",
                            fontSize: {
                                xs: "38px",
                                sm: "48px",
                                md: "60px",
                            },
                            lineHeight: 1,
                            mb: 2,
                            letterSpacing: "-1.5px",
                            textShadow:
                                "0 5px 35px rgba(0,0,0,0.6)",
                        }}
                    >
                        Server{" "}
                        <Box
                            component="span"
                            sx={{
                                color: "#ff6030",
                                textShadow:
                                    "0 0 30px rgba(255,82,35,0.22)",
                            }}
                        >
                            Rankings
                        </Box>
                    </Typography>

                    <Typography
                        sx={{
                            color: "rgba(255,255,255,0.55)",
                            maxWidth: "700px",
                            margin: "0 auto",
                            fontSize: {
                                xs: "14px",
                                md: "16px",
                            },
                            lineHeight: 1.8,
                        }}
                    >
                        Discover the strongest warriors, richest players,
                        deadliest fighters, and most powerful guilds
                        in Vex Conquer.
                    </Typography>

                    {/* FIRE DIVIDER */}
                    <Box
                        sx={{
                            width: 110,
                            height: 3,
                            borderRadius: "10px",
                            background:
                                "linear-gradient(90deg, transparent, #ff5420, #ff9a4d, #ff5420, transparent)",
                            mx: "auto",
                            mt: 3,
                            boxShadow:
                                "0 0 18px rgba(255,82,32,0.3)",
                        }}
                    />

                    {/* SERVER TAGS */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            flexWrap: "wrap",
                            gap: 1,
                            mt: 3,
                        }}
                    >
                        {[
                            "5165 CLASSIC",
                            "LEVEL 130",
                            "1ST REBORN",
                            "CLASSIC PVP",
                        ].map((tag) => (
                            <Box
                                key={tag}
                                sx={{
                                    px: 1.5,
                                    py: 0.7,
                                    borderRadius: "7px",
                                    border:
                                        "1px solid rgba(255,91,45,0.12)",
                                    background:
                                        "rgba(255,255,255,0.025)",
                                    color: "#777",
                                    fontSize: "9px",
                                    fontWeight: 800,
                                    letterSpacing: "1px",
                                }}
                            >
                                {tag}
                            </Box>
                        ))}
                    </Box>
                </Box>

                {/* =====================================================
                    RANKING TYPE SELECTOR
                ====================================================== */}
                <Box
                    sx={{
                        mb: { xs: 4, md: 5 },
                    }}
                >
                    <Box
                        sx={{
                            textAlign: "center",
                            mb: 1.5,
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#555",
                                fontSize: "9px",
                                fontWeight: 800,
                                letterSpacing: "2px",
                                textTransform: "uppercase",
                            }}
                        >
                            SELECT RANKING
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            flexWrap: "wrap",
                            gap: 1,
                            px: { xs: 0, md: 3 },
                        }}
                    >
                        {rankingButtons.map((btn) => (
                            <Button
                                key={btn.id}
                                onClick={() => setRankType(btn.id)}
                                sx={{
                                    minWidth: {
                                        xs: "auto",
                                        sm: "105px",
                                    },
                                    background:
                                        rankType === btn.id
                                            ? "linear-gradient(135deg, #ff5420, #b52a0d)"
                                            : "linear-gradient(145deg, rgba(255,255,255,0.055), rgba(255,255,255,0.018))",
                                    color:
                                        rankType === btn.id
                                            ? "#fff"
                                            : "#888",
                                    border:
                                        rankType === btn.id
                                            ? "1px solid rgba(255,130,80,0.75)"
                                            : "1px solid rgba(255,84,32,0.12)",
                                    borderRadius: "10px",
                                    px: {
                                        xs: 1.8,
                                        sm: 2.5,
                                    },
                                    py: 1.15,
                                    fontWeight: 800,
                                    fontSize: "12px",
                                    textTransform: "none",
                                    letterSpacing: "0.3px",
                                    boxShadow:
                                        rankType === btn.id
                                            ? "0 8px 28px rgba(255,67,25,0.2), inset 0 1px 0 rgba(255,255,255,0.18)"
                                            : "none",
                                    transition:
                                        "all 0.25s ease",

                                    "&:hover": {
                                        color: "#fff",
                                        borderColor:
                                            "rgba(255,91,45,0.5)",
                                        background:
                                            "linear-gradient(135deg, rgba(255,84,32,0.2), rgba(181,42,13,0.12))",
                                        transform:
                                            "translateY(-2px)",
                                    },
                                }}
                            >
                                {btn.name}
                            </Button>
                        ))}
                    </Box>
                </Box>

                {/* =====================================================
                    RANKING TABLE
                ====================================================== */}
                <Paper
                    elevation={0}
                    sx={{
                        background:
                            "linear-gradient(145deg, rgba(17,12,10,0.98), rgba(6,6,6,0.99))",
                        border:
                            "1px solid rgba(255,84,32,0.16)",
                        borderRadius: {
                            xs: "18px",
                            md: "24px",
                        },
                        overflow: "hidden",
                        boxShadow:
                            "0 25px 80px rgba(0,0,0,0.65), inset 0 1px 0 rgba(255,255,255,0.025)",
                        position: "relative",

                        "&:before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            height: "2px",
                            background:
                                "linear-gradient(90deg, transparent, #b52a0d, #ff7135, #ff9a4d, #ff5420, transparent)",
                        },

                        "&:after": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "30%",
                            height: "100%",
                            background:
                                "linear-gradient(90deg, rgba(255,75,30,0.025), transparent)",
                            pointerEvents: "none",
                        },
                    }}
                >

                    {/* =================================================
                        TABLE HEADER
                    ================================================== */}
                    <Box
                        sx={{
                            display: {
                                xs: "none",
                                sm: "grid",
                            },
                            gridTemplateColumns:
                                rankType === 255
                                    ? "80px 1.5fr 1fr 1fr 1fr"
                                    : "80px 1.5fr 1fr 1fr 1.2fr",
                            px: 4,
                            py: 2.2,
                            borderBottom:
                                "1px solid rgba(255,84,32,0.12)",
                            background:
                                "rgba(0,0,0,0.42)",
                        }}
                    >
                        <HeaderText>#</HeaderText>
                        <HeaderText>Name</HeaderText>
                        <HeaderText>Level</HeaderText>
                        <HeaderText>{getTitle()}</HeaderText>
                        <HeaderText>Guild</HeaderText>
                    </Box>

                    {/* =================================================
                        ROWS
                    ================================================== */}
                    {rankList.map((player, index) => (
                        <Box
                            key={index}
                            sx={{
                                display: "grid",
                                gridTemplateColumns: {
                                    xs: "50px 1fr",
                                    sm:
                                        rankType === 255
                                            ? "80px 1.5fr 1fr 1fr 1fr"
                                            : "80px 1.5fr 1fr 1fr 1.2fr",
                                },
                                px: {
                                    xs: 2,
                                    sm: 4,
                                },
                                py: {
                                    xs: 2.2,
                                    sm: 2.5,
                                },
                                borderBottom:
                                    index === rankList.length - 1
                                        ? "none"
                                        : "1px solid rgba(255,255,255,0.045)",
                                transition:
                                    "all 0.25s ease",
                                position: "relative",

                                background:
                                    index === 0
                                        ? "linear-gradient(90deg, rgba(255,76,30,0.09), transparent)"
                                        : index === 1
                                            ? "linear-gradient(90deg, rgba(255,255,255,0.035), transparent)"
                                            : index === 2
                                                ? "linear-gradient(90deg, rgba(181,83,36,0.045), transparent)"
                                                : "transparent",

                                "&:hover": {
                                    background:
                                        "linear-gradient(90deg, rgba(255,84,32,0.09), rgba(255,84,32,0.02))",
                                    boxShadow:
                                        "inset 3px 0 0 rgba(255,84,32,0.7)",
                                },
                            }}
                        >

                            {/* RANK */}
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontWeight: 900,
                                        fontSize:
                                            index < 3
                                                ? "16px"
                                                : "14px",
                                        color:
                                            index === 0
                                                ? "#ff7135"
                                                : index === 1
                                                    ? "#c8c8c8"
                                                    : index === 2
                                                        ? "#b56b3d"
                                                        : "#555",
                                        textShadow:
                                            index === 0
                                                ? "0 0 18px rgba(255,84,32,0.45)"
                                                : "none",
                                    }}
                                >
                                    #{index + 1}
                                </Typography>
                            </Box>

                            {/* NAME */}
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    minWidth: 0,
                                }}
                            >
                                {/* PLAYER BADGE */}
                                <Box
                                    sx={{
                                        width: 40,
                                        height: 40,
                                        minWidth: 40,
                                        mr: 1.5,
                                        borderRadius: "11px",
                                        display: {
                                            xs: "none",
                                            sm: "flex",
                                        },
                                        alignItems: "center",
                                        justifyContent: "center",
                                        background:
                                            index === 0
                                                ? "linear-gradient(135deg, rgba(255,84,32,0.2), rgba(181,42,13,0.08))"
                                                : "rgba(255,255,255,0.035)",
                                        border:
                                            index === 0
                                                ? "1px solid rgba(255,91,45,0.3)"
                                                : "1px solid rgba(255,255,255,0.05)",
                                        color:
                                            index === 0
                                                ? "#ff7135"
                                                : "#666",
                                        fontSize: "11px",
                                        fontWeight: 900,
                                        boxShadow:
                                            index === 0
                                                ? "0 0 20px rgba(255,70,25,0.1)"
                                                : "none",
                                    }}
                                >
                                    {index === 0
                                        ? "🔥"
                                        : index + 1}
                                </Box>

                                <Box
                                    sx={{
                                        minWidth: 0,
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: 800,
                                            color:
                                                index === 0
                                                    ? "#ff9a6b"
                                                    : "#eee",
                                            fontSize: {
                                                xs: "13px",
                                                sm: "14px",
                                            },
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {player.name}
                                    </Typography>

                                    {index === 0 && (
                                        <Typography
                                            sx={{
                                                color: "#9b4a2c",
                                                fontSize: "8px",
                                                fontWeight: 800,
                                                letterSpacing: "1.2px",
                                                mt: 0.25,
                                                textTransform:
                                                    "uppercase",
                                            }}
                                        >
                                            Current Leader
                                        </Typography>
                                    )}
                                </Box>
                            </Box>

                            {/* LEVEL */}
                            <Typography
                                sx={{
                                    color: "#999",
                                    fontWeight: 600,
                                    fontSize: "13px",
                                    display: {
                                        xs: "none",
                                        sm: "flex",
                                    },
                                    alignItems: "center",
                                }}
                            >
                                {player.level}
                            </Typography>

                            {/* POWER / PARAM */}
                            <Typography
                                sx={{
                                    color:
                                        index === 0
                                            ? "#ff7135"
                                            : "#aaa",
                                    fontWeight: 800,
                                    fontSize: "13px",
                                    display: {
                                        xs: "none",
                                        sm: "flex",
                                    },
                                    alignItems: "center",
                                }}
                            >
                                {player.param?.toLocaleString()}
                            </Typography>

                            {/* GUILD */}
                            <Typography
                                sx={{
                                    color: "#777",
                                    fontWeight: 600,
                                    fontSize: "13px",
                                    display: {
                                        xs: "none",
                                        sm: "flex",
                                    },
                                    alignItems: "center",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {player.guildName || "-"}
                            </Typography>

                            {/* MOBILE INFO */}
                            <Box
                                sx={{
                                    gridColumn: "2",
                                    display: {
                                        xs: "flex",
                                        sm: "none",
                                    },
                                    alignItems: "center",
                                    gap: 1.5,
                                    mt: 0.5,
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#777",
                                        fontSize: "11px",
                                        fontWeight: 600,
                                    }}
                                >
                                    Lv. {player.level}
                                </Typography>

                                <Box
                                    sx={{
                                        width: 3,
                                        height: 3,
                                        borderRadius: "50%",
                                        background:
                                            "#ff5420",
                                    }}
                                />

                                <Typography
                                    sx={{
                                        color:
                                            index === 0
                                                ? "#ff7135"
                                                : "#888",
                                        fontSize: "11px",
                                        fontWeight: 700,
                                    }}
                                >
                                    {player.param?.toLocaleString()}
                                </Typography>

                                <Box
                                    sx={{
                                        width: 3,
                                        height: 3,
                                        borderRadius: "50%",
                                        background:
                                            "#555",
                                    }}
                                />

                                <Typography
                                    sx={{
                                        color: "#666",
                                        fontSize: "11px",
                                        fontWeight: 600,
                                        overflow: "hidden",
                                        textOverflow:
                                            "ellipsis",
                                        whiteSpace:
                                            "nowrap",
                                    }}
                                >
                                    {player.guildName || "-"}
                                </Typography>
                            </Box>
                        </Box>
                    ))}

                    {/* =================================================
                        EMPTY
                    ================================================== */}
                    {rankList.length === 0 && (
                        <Box
                            sx={{
                                py: 10,
                                px: 3,
                                textAlign: "center",
                            }}
                        >
                            <Box
                                sx={{
                                    width: 58,
                                    height: 58,
                                    mx: "auto",
                                    mb: 2,
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background:
                                        "rgba(255,84,32,0.06)",
                                    border:
                                        "1px solid rgba(255,84,32,0.15)",
                                    color: "#ff5420",
                                    fontSize: "22px",
                                }}
                            >
                                ⚔
                            </Box>

                            <Typography
                                sx={{
                                    color: "#666",
                                    fontWeight: 700,
                                    fontSize: "14px",
                                }}
                            >
                                No rankings available
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#444",
                                    fontSize: "12px",
                                    mt: 1,
                                }}
                            >
                                Check back later for updated
                                rankings.
                            </Typography>
                        </Box>
                    )}
                </Paper>

                {/* =====================================================
                    RANKING INFORMATION STRIP
                ====================================================== */}
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "1fr",
                            sm: "repeat(3, 1fr)",
                        },
                        gap: 1,
                        mt: 2,
                    }}
                >
                    {[
                        {
                            value: "5165",
                            label: "CLASSIC CORE",
                        },
                        {
                            value: "130",
                            label: "MAX LEVEL",
                        },
                        {
                            value: "PVP",
                            label: "CLASSIC BATTLES",
                        },
                    ].map((item) => (
                        <Box
                            key={item.label}
                            sx={{
                                py: 2,
                                textAlign: "center",
                                border:
                                    "1px solid rgba(255,84,32,0.08)",
                                background:
                                    "rgba(255,255,255,0.018)",
                                borderRadius: "10px",
                            }}
                        >
                            <Typography
                                sx={{
                                    color: "#ff7135",
                                    fontSize: "15px",
                                    fontWeight: 900,
                                    letterSpacing: "1px",
                                }}
                            >
                                {item.value}
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#444",
                                    fontSize: "8px",
                                    fontWeight: 800,
                                    letterSpacing: "1.5px",
                                    mt: 0.3,
                                }}
                            >
                                {item.label}
                            </Typography>
                        </Box>
                    ))}
                </Box>

                {/* =====================================================
                    BOTTOM DECORATION
                ====================================================== */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mt: 5,
                        gap: 2,
                    }}
                >
                    <Box
                        sx={{
                            width: 70,
                            height: "1px",
                            background:
                                "linear-gradient(90deg, transparent, rgba(255,84,32,0.3))",
                        }}
                    />

                    <Typography
                        sx={{
                            color: "#444",
                            fontSize: "10px",
                            fontWeight: 700,
                            letterSpacing: "2px",
                            textTransform: "uppercase",
                        }}
                    >
                        Vex Conquer • 5165 Classic
                    </Typography>

                    <Box
                        sx={{
                            width: 70,
                            height: "1px",
                            background:
                                "linear-gradient(90deg, rgba(255,84,32,0.3), transparent)",
                        }}
                    />
                </Box>

            </Container>
        </Box>
    );
};

const HeaderText = ({ children }) => (
    <Typography
        sx={{
            color: "#ff7135",
            fontWeight: 800,
            fontSize: "10px",
            letterSpacing: "2px",
            textTransform: "uppercase",
        }}
    >
        {children}
    </Typography>
);

export default RankingsPage;

